// src/components/ProtectedRoute.tsx
import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoadingView from "./LoadingView";
import VerifyEmailView from "./VerifyEmailView";
import AccountNotFoundView from "./AccountNotFoundView";
import { useTenant } from "../contexts/TenantContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectPath = "/login",
}) => {
  const { user, loading: loadingUser } = useAuth();
  const { tenant, loading: loadingTenant } = useTenant();

  if (loadingUser) {
    return <LoadingView />;
  }

  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }

  if (loadingTenant) {
    return <LoadingView />;
  }

  if (!user.isAnonymous && !user.emailVerified) {
    return <VerifyEmailView />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
